export default {
  auth: {
    email: "E-mail",
    password: "Senha",
    logout: "Sair",
    sign_in: "Entrar",
    sign_in_with_sso: "Entrar com SSO",
    login_screen: "tela de login",
    back_to_sign_in: "Voltar para login",
    reset_password: "Redefinir Senha",
    reset_password_code: "Código de Redefinição de Senha",
    forget_password: "Esqueci a Senha",
    new_password: "Nova Senha",
    re_new_password: "Confirmar Nova Senha",
    login_failed: "Identidade não encontrada",
    change_password: "Alterar Senha",
    continue: "Continuar",
    showcase: {
      welcome: "Bem-vindo^3000",
      cloud: "Plataforma em nuvem de identificação e gerenciamento de próxima geração^4000",
      identify: "Permite identificar, rastrear e gerenciar sua força de trabalho^1000 de forma fácil e segura^4000",
      manage: "Você pode gerenciar quando e onde quiser^4000",
      freedom: "Você tem liberdade^3000 para ver todo o seu sistema^3000"
    },
    email_not_found: "Este endereço de e-mail não foi encontrado",
    invalid_reset_token: "Código de redefinição inválido",
    reset_password_expired: "Você deve aguardar pelo menos 3 minutos para redefinir uma nova senha",
    reset_code_expired: "O código de redefinição de senha expirou",
    send_sms_password_code: "O código de redefinição de senha foi enviado por SMS",
    password_change_successfully: "Sua senha foi alterada com sucesso",
    invalid_email_or_password: "E-mail ou senha inválidos",
    invalid_password: "Senha inválida",
    current_password: "Sua Senha Atual",
    sso_error: "Ocorreu um erro"
  },
  dashboard: {
    access: {
      table: {
        last_event: "Últimos Eventos",
        personal: "Funcionário",
        terminal_type: "Tipo de Terminal",
        general_info: "Informações Gerais",
        terminal: "Terminal",
        event_type: "Tipo de Evento",
        identity_type: "Tipo de Identidade",
        time: "Hora",
        event: "Evento",
        location: "Localização",
        place: "Local",
        place_beacon: "Beacon do Local",
        minor: "Minor",
        major: "Major",
        parent: "Principal",
        duration: "Duração",
        first_seen: "Primeira Visualização",
        last_seen: "Última Visualização",
        max_person_count: "Contagem Máxima de Pessoas",
        begin_date_time: "Data/Hora Inicial",
        end_date_time: "Data/Hora Final",
        employee_dialog_title: "Informações de Entrada/Saída do Funcionário",
        empty_zone_message: "Zona Vazia",
        loading_message: "Carregando"
      },
      monthly_dashboard: "Painel Mensal",
      monthly_events: "Eventos Mensais",
      monthly_timesheet_report: "Atrasos",
      absence: "Minhas Ausências",
      incalculable: "Meus Incalculáveis",
      lates: "Meus Atrasos",
      overtime: "Minhas Horas Extras",
      early_leaver: "Minhas Saídas Antecipadas",
      missing_time: "Minhas Horas Faltantes",
      expected: "Meu Esperado",
      total_tardiness_average: "Média de Atrasos",
      total_leaver_average: "Média de Saídas Antecipadas",
      total_overtime_average: "Média de Horas Extras",
      tardiness_minute: "Minutos de Atraso",
      early_minute: "Minutos Antecipados",
      overtime_minute: "Minutos Extras",
      short_minute: "min",
      today: "Hoje"
    },
    currency: {
      buying: "Compra",
      selling: "Venda",
      currencies: "Moeda"
    },
    about: {
      about: "Sobre",
      mission: "Missão",
      vision: "Visão"
    },
    menu_of_day: "Cardápio do Dia",
    messages: {
      no_data_reminders: "Sem lembretes",
      no_data_messages: "Sem mensagens",
      no_data_leaves: "Sem solicitações de folga",
      no_data_overtimes: "Sem solicitações de hora extra",
      no_data_expenses: "Sem solicitações de despesa",
      no_data_imprests: "Sem solicitações de adiantamento",
      no_data_incalculables: "Sem incalculáveis",
      no_data_absences: "Sem ausências"
    },
    request_type: {
      leave: "Solicitações de Folga",
      overtime: "Solicitações de Hora Extra",
      expense: "Solicitações de Despesa",
      imprest: "Solicitações de Adiantamento"
    },
    weather_forecast: "Previsão do Tempo & Taxas Atuais",
    reminder_tab_title: "Lembretes",
    message_tab_title: "Mensagens",
    data_type_enum: {
      LEAVE_REQUEST: "Solicitações de Folga",
      ACTIVITY: "Atividades",
      REMINDER: "Lembretes"
    }
  },
  time: {
    crud: {
      create_overtime: "Criar Solicitação de Hora Extra"
    },
    event: {
      clock_in: "Entrada",
      clock_out: "Saída",
      duty_in: "Início do Turno",
      duty_out: "Fim do Turno",
      break_in: "Início do Intervalo",
      break_out: "Fim do Intervalo",
      lunch_in: "Início do Almoço",
      lunch_out: "Fim do Almoço"
    },
    menu: {
      shifts: "Turnos",
      timesheets: "Folhas de Ponto",
      overtime_requests: "Solicitações de Hora Extra",
      overtime_approval: "Aprovações de Hora Extra",
      employee_calendar: "Calendário do Funcionário"
    },
    shift_types: {
      FIX: "Fixo",
      FLEXIBLE: "Flexível",
      OFF_DAY: "Dia de Folga",
      OFFDAY: "Dia de Folga",
      HOLIDAY: "Feriado",
      WORKDAY: "Dia de Trabalho",
      BREAK: "Dia de Descanso"
    },
    overtime_approval: {
      employee: "Funcionário",
      workplan: "Plano de Trabalho",
      request_status: "Status da Solicitação",
      reason: "Motivo",
      request_time: "Data da Solicitação"
    },
    overtime_request: {
      approve_title: "Aprovação de Hora Extra",
      add_overtime: "Adicionar Hora Extra",
      date: "Data do Turno",
      workplan: "Turno",
      overtime_in_minutes: "Duração da Hora Extra",
      short_minute: "min",
      request_status: "Status",
      request_date: "Data da Solicitação",
      period: "Período",
      periods: {
        CLOCK_IN: "Entrada",
        CLOCK_OUT: "Saída",
        CLOCK_IN_OUT: "Entrada e Saída"
      },
      message: "{0} Deseja aprovar a solicitação de hora extra de <b>{2} minutos para o turno em {1}</b>",
      selectedShiftForOvertime: "Turno com horas extras"
    },
    timesheet: {
      employee: "Funcionário",
      employees: "Funcionários",
      date: "Data",
      type: "Tipo",
      work_plan: "Plano de Trabalho",
      shift: "Turno",
      clock_in: "Entrada",
      clock_in_title: "Horário de Entrada",
      late: "Atraso",
      reason: "Motivo",
      late_title: "Atraso na Entrada",
      it: "TI",
      it_title: "Tipo de Identidade",
      terminal: "Terminal",
      clock_out: "Saída",
      clock_out_title: "Horário de Saída",
      early: "Antecipado",
      early_title: "Saída Antecipada",
      ewt: "HTE",
      ewt_title: "Horário de Trabalho Esperado",
      awt: "HTA",
      twt_title: "Tempo Total de Trabalho",
      twt: "TTT",
      awt_title: "Horário de Trabalho Real",
      ot: "HE",
      ot_title: "Hora Extra",
      mt: "HF",
      mt_title: "Horas Faltantes",
      name: "Funcionário",
      time: "Hora",
      identity_type: "Tipo de Identidade",
      event_type: "Tipo de Evento",
      event_time: "Hora do Evento",
      all_events: "Todos os Eventos",
      status: "Status",
      shift_name: "Nome do Turno",
      branch: "Filial",
      unit: "Unidade",
      team: "Equipe",
      jobInfo: "Informações do Cargo",
      staffNumber: "Número do Funcionário",
      information: {
        work_day: "Dia de Trabalho",
        work_day_desc: "Significa que o funcionário virá trabalhar neste dia.",
        work_off: "Folga",
        work_off_desc: "Este dia é folga de fim de semana para o funcionário.",
        public_holiday: "Feriado",
        public_holiday_desc: "Este é um feriado público para o funcionário.",
        did_not_come_to_work: "Não compareceu ao trabalho",
        did_not_come_to_work_desc: "O funcionário não veio trabalhar apesar de ter um turno para este dia.",
        on_leave: "De Folga",
        on_leave_desc: "O funcionário está de folga neste dia.",
        calculated: "Calculado",
        calculated_desc: "Significa que o cálculo foi feito para as palavras em verde.",
        not_calculated: "Não Calculado",
        not_calculated_desc: "Significa que o cálculo não foi feito para as palavras em vermelho."
      },
      total: "Total",
      ot_mt: "Diferença"
    },
    calendar: {
      holiday: "Feriado",
      off_day: "Dia de Folga",
      breakday: "Dia de Descanso",
      employee_overtime: "Se o funcionário vier trabalhar nesta data, será calculado como hora extra",
      employee_off_day: "É o dia de folga semanal do funcionário",
      employee_break_day: "É o dia de descanso do funcionário",
      shift_loading: "Idenfit criando turnos",
      create_shift: "Criar Turno",
      shift_detail: "Detalhes do Turno",
      leave_type: "Tipo de Folga",
      begin_time: "Hora de Início",
      end_time: "Hora de Término",
      break_time: "Tempo de Intervalo",
      shift_time: "Horário do Turno",
      clock_in_max_overtime: "Máximo de Hora Extra na Entrada",
      clock_out_max_overtime: "Máximo de Hora Extra na Saída",
      lately_tolerance: "Tolerância de Atraso",
      early_tolerance: "Tolerância de Saída Antecipada",
      overtime: "Hora Extra",
      early_clock_out_tolerance: "Tolerância de Atraso",
      lately_clock_in_tolerance: "Tolerância de Saída Antecipada",
      max_clock_in_overtime_in_minutes: "Máximo de Hora Extra na Entrada em Minutos",
      max_clock_out_overtime_in_minutes: "Máximo de Hora Extra na Saída em Minutos",
      min_clock_in_overtime_in_minutes: "Mínimo de Hora Extra na Entrada em Minutos",
      min_clock_out_overtime_in_minutes: "Mínimo de Hora Extra na Saída em Minutos",
      minimum_overtime: "Hora extra mínima",
      maximum_overtime: "Hora extra máxima",
      midnight_tolerance: "Tolerância de Meia-noite",
      shift_type: "Tipo de Turno",
      count_as_overtime: "Contar como hora extra",
      total_work_time: "Tempo Total de Trabalho",
      selectWeekends: "Dias de Fim de Semana",
      selectBreaks: "Dias de Intervalo",
      overtime_request: {
        approve_title: "Aprovando Hora Extra",
        add_overtime: "Solicitar Hora Extra",
        detail_overtime: "Detalhes da Hora Extra",
        date: "Data do Turno",
        workplan: "Turno",
        overtime_in_minutes: "Tempo do Turno",
        request_status: "Status",
        request_date: "Data da Solicitação",
        approval_date: "Data de Aprovação",
        period: "Período",
        history: "Histórico de Aprovação",
        periods: {
          CLOCK_IN: "Entrada",
          CLOCK_OUT: "Saída",
          CLOCK_IN_OUT: "Entrada e Saída"
        },
        approved: "{0} Deseja aprovar a solicitação de hora extra de <b>{2} minutos para o turno em {1}</b>?",
        rejected: "{0} Deseja rejeitar a solicitação de hora extra de <b>{2} minutos para o turno em {1}</b>?",
        approval_to_manager: "Enviar para aprovação do Gestor de Hora Extra",
        not_approval_to_manager: "Não enviar para aprovação do Gestor de Hora Extra",
        pending_approval_manager: "Gestor Pendente de Aprovação",
        processes: {
          approved: "Solicitação aprovada",
          pending: "Aguardando aprovação",
          stopped: "Processo de aprovação interrompido pois a solicitação foi cancelada",
          waiting: "Aguardando aprovação do gestor anterior",
          denied: "Solicitação cancelada"
        }
      },
      multiple_shift_deleting: "Exclusão Múltipla de Turnos",
      cancel_request: "Cancelar Solicitação",
      cancel_request_title: "Cancelar Solicitação de Turno"
    }
  },
  leave: {
    crud: {
      create: "Adicionar Solicitação de Folga"
    },
    menu: {
      leave_accruals: "Acúmulo de Folgas",
      leave_requests: "Solicitações de Folga",
      leave_approvals: "Aprovações de Folga Pendentes",
      leave_balances: "Saldos de Licença"
    },
    hourly: "Por Hora",
    daily: "Diário",
    type: "Tipo de Folga",
    begin_time: "Hora de Início",
    end_time: "Hora de Término",
    begin_date: "Data de Início",
    end_date: "Data de Término",
    approved_time: "Data de Aprovação",
    request_time: "Hora da Solicitação",
    approve_or_reject: "Aprovar ou Rejeitar",
    status: "Status",
    no_approver: "Sem Aprovador",
    manager: "Gestor de Folgas",
    managers: "Gestores de Folgas",
    balance: "Saldo",
    not_leave_accruals: "Este funcionário ainda não tem direito a folga",
    permission: {
      employee_leave_approver_message: "Este funcionário pode aprovar solicitações de permissão de outros funcionários",
      employee_not_leave_approver_message:
        "Este funcionário não pode aprovar solicitações de permissão de outros funcionários",
      employee_shift_approver_message: "Este funcionário pode atribuir turnos a outros funcionários",
      employee_not_shift_approver_message: "Este funcionário não pode atribuir turnos a outros funcionários",
      employee_overtime_approver_message:
        "Este funcionário pode aprovar solicitações de hora extra de outros funcionários",
      employee_not_overtime_approver_message:
        "Este funcionário não pode aprovar solicitações de hora extra de outros funcionários"
    },
    notification: {
      employee_receiver_leave_notification_message:
        "Estes funcionários podem receber avisos de permissão de outros funcionários",
      employee_not_receiver_leave_notification_message:
        "Este funcionário não pode receber avisos de permissão de outros funcionários",
      employee_receiver_shift_notification_message:
        "Estes funcionários podem receber notificações de atribuição de turno de outros funcionários",
      employee_not_receiver_shift_notification_message:
        "Este funcionário não pode receber notificações de atribuição de turno de outros funcionários",
      employee_receiver_overtime_notification_message:
        "Estes funcionários podem receber notificações de solicitação de hora extra de outros funcionários",
      employee_not_receiver_overtime_notification_message:
        "Este funcionário não pode receber notificações de solicitação de hora extra de outros funcionários"
    },
    respect: "Os gestores de permissão acima terão prioridade",
    order_is_important: "A ordem dos gestores é importante",
    already_selected_manager: "Você já selecionou este gestor",
    there_is_no_leave_manager: "Nenhum gestor de folgas atribuído",
    add_leave_manager: "Adicionar Gestor de Folgas",
    used: "Usado",
    remaining: "Restante",
    on_leave: "De Folga",
    period: "Período",
    duration: "Duração",
    periods: {
      first_half: "1ª Metade",
      second_half: "2ª Metade",
      first_quarter: "1º Quarto",
      second_quarter: "2º Quarto",
      third_quarter: "3º Quarto",
      fourth_quarter: "4º Quarto"
    },
    request: {
      this_day_does_not_count_as_leave: "Este dia não conta como folga",
      leave_balance: "Saldo de Folgas",
      max_exceed_leave_balance: "Saldo Máximo de Folgas Excedido",
      leave_request_count: "Quantidade de Solicitações de Folga",
      used: "Usado",
      remaining: "Restante",
      approved: "Aprovar",
      denied: "Negar",
      leave_decreased_count: "A folga será diminuída"
    },
    accruals: {
      name: "Nome",
      count: "Acúmulo de Folgas",
      used: "Usado",
      balance: "Saldo Atual",
      previous_balance: "Saldo Anterior"
    },
    approvals: {
      leave_approval: "Aprovação de Folga",
      message:
        "O saldo de folgas do tipo <b>{1}</b> de <b>{0}</b> é de <b>{2}</b> dias. Deseja aprovar um total de <b>{5}</b> solicitações de folga diárias feitas entre <b>{3}</b> - <b>{4}</b>?"
    },
    cancels: {
      leave_cancel: "Revogar Folga",
      message: "Qual o motivo para revogar a folga?",
      error_message: "O campo motivo do cancelamento é obrigatório"
    },
    error_messages: {
      notice_period_error: "Esta folga deve ser solicitada com pelo menos {0} dias de antecedência",
      max_consecutive_error: "Você pode solicitar até {0} dias de folga por vez",
      min_consecutive_error: "Você pode solicitar no mínimo {0} dias de folga por vez",
      leave_request_exist_error: "Já existe uma solicitação de folga nestas datas",
      total_leave_balance_error1: "Você não tem saldo suficiente para esta folga",
      total_leave_balance_error2:
        "Para esta folga, você pode usar no máximo {0} dias do saldo antecipado, você não pode solicitar folga porque seu saldo antecipado é insuficiente.",
      invalid_dates_error: "Datas inválidas",
      on_birthday_error: "Você só pode usar esta folga no seu aniversário",
      birthday_week_error: "Você só pode usar esta folga durante a semana do seu aniversário",
      birthday_month_error: "Você só pode usar esta folga durante o mês do seu aniversário"
    },
    e_signature: "Assinatura Digital",
    e_signature_leave_form: "Formulário de Folga com Assinatura Digital",
    leave_form: "Formulário de Folga",
    leave_cancel: "Cancelar Folga",
    signed: "Assinado",
    not_signed: "Não Assinado",
    requests: {
      days_off_automatically: "Dias adicionados automaticamente",
      requested_leave_type_documents: "Os arquivos precisam ser documentos para folga"
    },
    today_counts_as_a_day_off: "Hoje é considerado um dia de folga",
    required_document_message:
      " | Há {count} documento que você precisa enviar | Há {count} documentos que você precisa enviar",
    isNexyDayMessage: "A folga começa no dia seguinte"
  },
  leave_request_status: {
    pending: "Pendente",
    PENDING: "Pendente",
    approved: "Aprovado",
    APPROVED: "Aprovado",
    denied: "Negado",
    DENIED: "Negado",
    cancelled: "Cancelado",
    CANCELLED: "Cancelado",
    need_extra_detail: "Necessita detalhes adicionais",
    NEED_EXTRA_DETAIL: "Necessita detalhes adicionais",
    null: "Desconhecido",
    NULL: "Desconhecido",
    undefined: "Desconhecido",
    UNDEFINED: "Desconhecido",
    closed: "Fechado",
    CLOSED: "Fechado",
    close_pending: "Fechamento Pendente",
    CLOSE_PENDING: "Fechamento Pendente",
    NOT_COME: "Não Compareceu",
    not_come: "Não Compareceu",
    super_admin: "Aprovação do Admin",
    SUPER_ADMIN: "Aprovação do Admin"
  },
  time_duration: {
    hour: "Hora",
    minute: "Minuto",
    second: "Segundo"
  },
  leave_type: {
    paid: "Remunerado",
    unpaid: "Não Remunerado",
    on_duty: "Em Serviço",
    restricted_holiday: "Feriado Restrito"
  },
  leave_status: {
    APPROVED: "Aprovado",
    PENDING: "Pendente",
    DENIED: "Negado",
    CANCELLED: "Cancelado",
    NEED_EXTRA_DETAIL: "Necessita Detalhes Adicionais",
    not_come: "Não chegou a hora",
    NOT_COME: "Não chegou a hora"
  },
  leave_duration: {
    FULL_DAY: "Dia Inteiro",
    HALF_DAY: "Meio Dia",
    QUARTER_DAY: "Quarto de Dia",
    HOURLY_DAY: "Dia por Hora",
    HOURLY: "Por Hora"
  },
  hr: {
    menu: {
      profile: "Perfil",
      performances: "Desempenhos",
      hiring: "Contratação",
      trainings: "Treinamentos",
      expenses: "Despesas",
      imprests: "Adiantamentos",
      papers: "Documentos",
      paper: "Documento",
      documents: "Documentos",
      health: "Saúde",
      debit_tickets: "Vales",
      payroll: "Folha de Pagamento",
      events: "Eventos",
      approvals: "Solicitações de Aprovação",
      expense_approval: "Solicitações de Despesa",
      imprest_approval: "Solicitações de Adiantamento",
      messages: "Mensagens",
      inbox: "Caixa de Entrada",
      outbox: "Caixa de Saída",
      suggestions: "Sugestões",
      notes: "Notas",
      travels: "Viagens",
      travel_requests: "Solicitações de Viagem",
      vehicles: "Veículos",
      menus: "Cardápio",
      contact: "Contato",
      expense: "Despesa",
      expense_request_history: "Histórico de Solicitações de Despesa",
      imprest: "Adiantamento",
      imprest_request_history: "Histórico de Solicitações de Adiantamento",
      travel: "Viagem",
      travel_request_history: "Histórico de Solicitações de Viagem",
      debit_ticket_transfer_requests: "Solicitações de Transferência de Vale",
      training: "Treinamento",
      training_requests: "Solicitações de Treinamento",
      training_request_history: "Histórico de Solicitações de Treinamento",
      survey: "Pesquisa",
      pending_surveys: "Pesquisas Pendentes",
      completed_surveys: "Pesquisas Concluídas",
      expired_surveys: "Pesquisas Expiradas",
      paper_request_history: "Histórico de Solicitações de Documentos",
      paper_requests: "Solicitações de Documentos",
      tasks: "Tarefas"
    },
    account: {
      overview: "Visão Geral",
      email: "E-mail",
      information: "Informações",
      language_role: "Idioma e Função",
      profile: "Perfil",
      contact: "Contato",
      personal: "Pessoal",
      family: "Família",
      education: "Educação",
      employment: "Emprego",
      financial: "Financeiro",
      social_media: "Redes Sociais",
      body_size: "Medidas Corporais",
      mobile_device: "Dispositivos Móveis",
      special_fields: "Campos Especiais",
      messages: "Mensagens",
      notes: "Notas",
      management: "Gestão"
    },
    employee: {
      overview: {
        staff_number: "Número do Funcionário",
        branch: "Filial",
        unit: "Unidade",
        team: "Equipe",
        email: "E-mail",
        job_info: "Informações do Cargo",
        title: "Título",
        leave: {
          manager: "Gestor de Folgas",
          managers: "Gestores de Folgas",
          approver: "Aprovador de Folgas"
        },
        hired_date: "Data de Contratação",
        status: "Status",
        manager: "Gestor",
        shift_manager: "Gestor de Turno",
        shift_managers: "Gestores de Turno",
        role: "Função"
      },
      information: {
        identity_number: "Número de Identidade",
        first_name: "Nome",
        last_name: "Sobrenome",
        work_email: "E-mail Corporativo",
        phone: "Telefone",
        email_and_sms_send_question: "Enviar notificações por e-mail e SMS para este funcionário?"
      },
      profile: {
        identity_number: "Número de Identidade",
        first_name: "Nome",
        last_name: "Sobrenome",
        work_email: "E-mail Corporativo",
        phone: "Telefone",
        email_and_sms_send_question: "Enviar notificações por e-mail e SMS para este funcionário?",
        service_line: "Linha de Serviço"
      },
      language_role: {
        language: "Idioma",
        role: "Função"
      },
      contact: {
        email: "E-mail",
        address: "Endereço",
        secondary_phone: "Telefone Secundário",
        fixed_phone: "Telefone Fixo",
        work_phone: "Telefone Comercial",
        spouse_phone: "Telefone do Cônjuge",
        extension_number: "Ramal",
        emergency_contact_name: "Nome do Contato de Emergência",
        emergency_contact_phone: "Telefone do Contato de Emergência"
      },
      personal: {
        pasaport_number: "Número do Passaporte",
        birth_date: "Data de Nascimento",
        place_of_birth: "Local de Nascimento",
        nationality: "Nacionalidade",
        blood_type: "Tipo Sanguíneo",
        gender: "Gênero",
        disability_level: "Nível de Deficiência",
        ex_convict: "Ex-Presidiário",
        driver: "Motorista",
        military_service: "Serviço Militar",
        suspended_until: "Suspenso Até",
        hes_code: "Código HES",
        hes_expired_date: "Data de Expiração do Código HES"
      },
      family: {
        marital_status: "Estado Civil",
        spouse_name: "Nome do Cônjuge",
        child_count: "Número de Filhos",
        tenant: "Inquilino",
        martyrs_relatives: "Parentes Mártires",
        disability_child_count: "Número de Filhos com Deficiência",
        date_of_marriage: "Data do Casamento",
        father_name: "Nome do Pai",
        mother_name: "Nome da Mãe",
        mothers_maiden_name: "Sobrenome de Solteira da Mãe",
        sibling_count: "Número de Irmãos",
        child_info: "Informações dos Filhos",
        add_child_info: "Adicionar Informações do Filho"
      },
      education: {
        graduation: "Formação",
        school: "Escola",
        faculty: "Faculdade",
        department: "Departamento",
        graduation_grade: "Nota de Graduação",
        academic_title: "Título Acadêmico",
        languages: "Idiomas",
        licence_file: "Arquivo de Licença"
      },
      employment: {
        staff_number: "Número do Funcionário",
        branch: "Filial",
        unit: "Unidade",
        team: "Equipe",
        job_info: "Informações do Cargo",
        manager: "Gestor",
        agency: "Agência",
        ssn: "CPF",
        passive: "Passivo",
        hired_date: "Data de Contratação",
        started_date: "Data de Início",
        employment_type: "Tipo de Contratação",
        collar_type: "Tipo de Colarinho",
        quite_job: "Deixou o Emprego",
        quit_job_reason: "Motivos de Saída",
        quit_job_reason_description: "Descrição",
        description: "Descrição",
        quit_job_date: "Data de Saída",
        have_an_interview_made: "Entrevista Realizada",
        have_an_interview_made_not: "Sem Entrevistas Realizadas",
        integration_value: "Número de Integração",
        research_and_development_person: "Funcionário de P&D",
        social_security_type: "Tipo de Previdência Social",
        company: "Empresa",
        allowance_date: "Data de Início do Benefício"
      },
      financial: {
        iban: "IBAN",
        ticket_number: "Número do Vale",
        bank_account_number: "Número da Conta Bancária",
        bank_branch: "Agência Bancária",
        salary: "Salário",
        ticket_price: "Valor do Vale",
        previous_salary: "Salário Anterior",
        previous_ticket_price: "Valor Anterior do Vale",
        yearly_premium: "Prêmio Anual",
        monthly_stoppage: "Desconto Mensal",
        health_insurance_person_count: "Número de Pessoas no Plano de Saúde",
        agi: "Salário Mínimo",
        gross_salary: "Salário Bruto",
        pay_to_net: "Salário Líquido",
        pay_to_gross: "Salário Bruto",
        salary_type: "Tipo de Pagamento de Salário"
      },
      social_media: {
        facebook: "Facebook",
        twitter: "Twitter",
        instagram: "Instagram",
        linkedin: "LinkedIn",
        skype: "Skype"
      },
      body_size: {
        weight: "Peso",
        height: "Altura",
        shirt_size: "Tamanho da Camisa",
        pants_size: "Tamanho da Calça",
        shoe_size: "Tamanho do Sapato",
        waistcoat: "Colete",
        coat: "Casaco"
      },
      management: {
        manager: "Gestor",
        leave_managers: "Gestores de Folga",
        shift_managers: "Gestores de Turno",
        overtime_managers: "Gestores de Hora Extra",
        expense_managers: "Gestores de Despesa"
      },
      mobile_device: {
        serial_number: "Número de Série",
        multiple_device_allowed: "Múltiplos Dispositivos Permitidos"
      }
    },
    performance: {
      results: {
        evaluatee: "Avaliado",
        published_evaluators: "Avaliadores Publicados",
        unpublished_evaluators: "Avaliadores Não Publicados",
        kpi_score: "Pontuação KPI",
        competence_score: "Pontuação de Competência",
        totalCount: "Total de Participantes",
        publishedCount: "Participantes Ativos",
        evaluation_name: "Nome da Avaliação",
        total_score: "Pontuação Total",
        status: "Status",
        period: "Período",
        scoring: "Pontuação",
        beginDate: "Data de Início",
        endDate: "Data de Término"
      },
      table: {
        name: "Nome",
        type: "Tipo de Desempenho",
        score_range: "Faixa de Pontuação",
        evaluatee: "Funcionário a ser Avaliado",
        expiration_period: "Período de Expiração",
        validation_period: "Período de Validação",
        status: "Status da Avaliação",
        categories: "Categorias"
      },
      depths: {
        depth_1: "1º Nível",
        depth_2: "2º Nível",
        depth_3: "3º Nível",
        depth_4: "4º Nível",
        depth_5: "5º Nível"
      },
      add: {
        kpi: "Adicionar KPI",
        competence: "Adicionar Competência",
        pool: "Quero adicionar do pool",
        custom: "Quero adicionar novo",
        kpi_group: "Adicionar Grupo de KPI",
        competence_group: "Adicionar Grupo de Competência"
      },
      detail: {
        kpi_group: "Detalhes do Grupo de KPI",
        competence_group: "Detalhes do Grupo de Competência"
      },
      crud: {
        detail: {
          template: "Detalhes do Modelo",
          evaluation: "Detalhes do Plano de Avaliação"
        }
      },
      type: {
        KPI: "KPI",
        COMPETENCE: "Competência"
      },
      validation: {
        add_item: "Você deve adicionar questões à categoria {0}",
        template_exist_category: "Categoria {0} foi adicionada",
        template_must_a_category: "Deve haver pelo menos uma categoria no modelo de desempenho",
        question_total_weight_required: "O peso total das questões deve ser {0}%",
        question_total_weight: "Peso total das questões {0}%",
        category_not_exist: "Esta categoria não existe",
        category_total_weight_equals_in_questions:
          "Como o peso total da categoria {0} é {1}%, o peso total das questões pertencentes a esta categoria deve ser {1}%.",
        category_in_question_required: "Deve haver pelo menos uma questão na categoria {0}",
        question_weight_required: "Digite o peso de {0}"
      },
      information:
        '<p class="body-1 mt-5">' +
        "Você pode criar sua lista de KPI e competências selecionando as categorias KPI & COMPETÊNCIA." +
        "</p>" +
        '<p class="body-1">' +
        "Você pode fazer pontuação baseada em questões inserindo seus pesos nas questões de KPI e competência definidas na categoria selecionada" +
        "</p>" +
        '<p class="body-1">' +
        "A soma das questões na lista que você adicionou deve ser igual ao peso que você definiu para KPI ou COMPETÊNCIA." +
        "</p>",
      total_evaluatees_count: "Total de avaliados {0}",
      waiting_evaluates_finish: "Espera-se que {0} pessoas completem a avaliação",
      complete_evaluation: "Esta avaliação foi concluída",
      expiration_date: "Data de Expiração",
      template_name: "Nome do Modelo",
      kpi: "KPI",
      kpi_category: "Categoria de KPI",
      kpis: "KPIs",
      competence: "Competência",
      competence_category: "Categoria de Competência",
      competences: "Competências",
      result_view: "Mostrar Resultados",
      waiting: "Aguardando",
      hourly: "Por Hora",
      weekly: "Semanal",
      monthly: "Mensal",
      yearly: "Anual",
      score: "Pontuação",
      star: "Estrela",
      weight: "Peso",
      point: "Ponto",
      person: "Pessoa",
      persons: "Pessoas",
      period_type: "Período",
      score_type: "Tipo de Pontuação",
      score_min_count: "Pontuação Mínima",
      score_max_count: "Pontuação Máxima",
      evaluation: "Avaliação",
      evaluates: "Avaliados",
      evaluators: "Avaliadores",
      self: "Auto",
      superior: "Superior",
      subordinates: "Subordinados",
      same: "Mesmo",
      flexible: "Flexível",
      period: "Período",
      expiration_dates: "Data de Expiração",
      expiration_begin_date: "Data de Início da Expiração",
      expiration_end_date: "Data de Fim da Expiração",
      level: "Nível",
      depth: "Profundidade",
      validation_date: "Data de Validação",
      validation_begin_date: "Data de Início da Validação",
      validation_end_date: "Data de Fim da Validação",
      published_date_time: "Data de Publicação",
      degree_360: "360°",
      m2m: "M2M",
      published: "Iniciar Avaliação",
      published_start: "Iniciar Avaliação",
      evaluation_done: "Avaliação Concluída",
      are_you_sure: "Você tem certeza?",
      are_you_text: "Deseja iniciar esta avaliação?",
      performance_item: {
        title: "Desempenho"
      },
      my_evaluatees: "Meus Avaliados",
      my_evaluated: "Minhas Avaliações",
      info_dialog_title: "Informação",
      info_dialog_message:
        "Sua avaliação foi processada, quando o processo for concluído, sua avaliação será refletida no sistema."
    },
    training: {
      plan: "Plano de Treinamento",
      name: "Nome do Treinamento",
      type: "Tipo de Treinamento",
      organizer: "Organizador",
      lecturer: "Instrutor",
      terminal: "Terminal",
      sessions: "Sessões",
      session: "Sessão",
      training_type: {
        ONLINE: "Online",
        CLASSROOM: "Presencial",
        ON_SITE: "No Local"
      },
      training_detail: "Detalhes do Treinamento",
      location: "Local",
      description: "Descrição",
      training: "Treinamento",
      request_training: "Solicitar Treinamento",
      training_requests: "Solicitações de Treinamento",
      request_date: "Data da Solicitação",
      abolisher: "Cancelador",
      approval_history: "Histórico de Aprovações",
      cancelled_date: "Data de Cancelamento",
      hr_manager: "Gestor de RH",
      approval_date: "Data de Aprovação",
      cancel_request: "Cancelar Solicitação",
      cancellation_note: "Nota de cancelamento?",
      request_cancellation_process: "Processo de Cancelamento de Solicitação de Treinamento",
      request_approval_process: "Processo de Aprovação de Solicitação de Treinamento",
      denied: "Negar",
      approved: "Aprovar",
      training_planned: "Treinamento Planejado"
    },
    expense: {
      name: "Nome da Despesa",
      type: "Tipo de Despesa",
      amount: "Valor",
      date: "Data Solicitada",
      status: "Status",
      attachment: "Anexo",
      create_expense: "Solicitar uma Despesa",
      travel: "Viagem",
      approved_amount: "Valor Aprovado",
      expense_type: {
        expense_type: "Tipo de Despesa"
      },
      payment_type: {
        CASH: "Dinheiro",
        CREDIT_CARD: "Cartão de Crédito",
        PREPAID_CARD: "Cartão Corporativo",
        OTHER: "Outro",
        null: "Não Especificado"
      }
    },
    imprest: {
      amount: "Valor",
      period: "Período do Adiantamento",
      reason: "Motivo",
      status: "Status",
      create_imprest: "Solicitar um Adiantamento",
      travel: "Viagem",
      approved_amount: "Valor Aprovado",
      date: "Data"
    },
    paper: {
      name: "Nome do Documento",
      type: "Tipo de Documento",
      issue_date: "Data de Emissão",
      expire_date: "Data de Vencimento",
      signature_status: "Status da Assinatura",
      edit_paper: "Editar Documento",
      paper_include_process: "A aprovação do documento deve ser enviada ao Gestor de Recursos Humanos para aprovação",
      paper_not_include_process:
        "A aprovação do documento não deve ser enviada ao Gestor de Recursos Humanos para aprovação",
      paper_required_fields_missing: "Tipo de documento e status da assinatura estão faltando. Por favor, complete-os.",
      signature_types: {
        NOT_REQUIRED: "Não Requerido",
        STANDARD_SIGNATURE: "Assinatura Padrão",
        BIOMETRIC_SIGNATURE: "Assinatura Biométrica",
        SIGNED: "Assinado",
        null: "-",
        E_SIGNATURE: "Assinatura Digital"
      },
      add_paper: "Adicionar Documento",
      papers: {
        issue_date: "Data de Emissão",
        expire_date: "Data de Vencimento"
      }
    },
    document: {
      name: "Nome do Documento",
      type: "Tipo de Documento",
      category: "Categoria do Documento",
      sender: "Remetente",
      date: "Data",
      add_document: "Adicionar Documento",
      mobile_accessible_disable: "Acesso móvel desativado",
      mobile_accessible_enable: "Acesso móvel ativado"
    },
    health: {
      name: "Nome",
      category: "Categoria",
      from: "Data Inicial",
      to: "Data Final",
      disease_detail: "Detalhes da Doença",
      importance: "Importância",
      importance_enum: {
        LOW: "Baixa",
        MEDIUM: "Média",
        HIGH: "Alta"
      },
      medicines: "Medicamentos",
      attachment: "Anexo",
      description: "Descrição"
    },
    debit_tickets: {
      asset: "Ativo",
      borrow_date: "Data do Empréstimo",
      due_date: "Data de Vencimento",
      give_back_date: "Data de Devolução",
      quantity: "Quantidade",
      transfer: "Transferência",
      transfer_approval: "Aprovação de Transferência",
      approver: "Funcionário a ser Transferido",
      debit_transfer: "Transferência de Débito",
      download_form: "Baixar Formulário",
      DEBIT_TRANSFER_DUPLICATE_EXCEPTION: "Existe uma solicitação de transferência previamente criada para este débito",
      DATA_INTEGRITY_VIOLATION_EXCEPTION: "Este débito já foi registrado para você"
    },
    payroll: {
      month: "Mês",
      created_date: "Data de Criação",
      file: "Arquivo"
    },
    events: {
      name: "Nome",
      type: "Tipo",
      owner: "Proprietário",
      online: "Online",
      begin_date: "Data de Início",
      end_date: "Data de Término",
      activity: "Atividade"
    },
    expense_approval: {
      employee: "Funcionário",
      description: "Descrição",
      amount: "Valor",
      status: "Status",
      request_date: "Data da Solicitação",
      document: "Documento",
      expense_approval: "Aprovação de Despesa",
      message: "{0} solicitou uma despesa no valor de <b>{3}</b> do tipo <b>{2}</b> em <b>{1}</b>, deseja aprovar?"
    },
    imprest_approval: {
      employee: "Funcionário",
      amount: "Valor",
      status: "Status",
      request_date: "Data da Solicitação",
      imprest_approval: "Aprovação de Adiantamento",
      message: "{0} solicitou um adiantamento no valor de <b>{2}</b> em <b>{1}</b>, deseja aprovar?",
      approved_amount: "Valor Aprovado",
      requested_amount: "Valor Solicitado"
    },
    hiring: {
      job_posting: "Vaga de Emprego",
      applicant: "Candidato",
      applicants: "Candidatos",
      interview: "Entrevista",
      assessment_date: "Data de Avaliação",
      working_date: "Data de Trabalho",
      last_job: "Último Emprego",
      last_position_level: "Último Nível de Cargo",
      evaluator: "Avaliador",
      evaluators: "Avaliadores",
      weight: "Peso",
      link: "Link",
      skill: "Habilidade",
      rate: "Taxa",
      rating: "Avaliação",
      table: {
        applicant: "Candidato",
        job_posting: "Vaga de Emprego",
        last_job: "Último Emprego",
        assessment: "Avaliação",
        rating: "Avaliação",
        assessment_date: "Data de Avaliação",
        status: "Status",
        evaluators: "Avaliadores",
        evaluator: "Avaliador"
      },
      skill_type: {
        soft: "Comportamental",
        technical: "Técnica",
        question: "Pergunta",
        link: "Link"
      }
    },
    message: {
      message_type: "Tipo de Mensagem",
      sender: "Remetente",
      receivers: "Destinatários",
      importance: "Importância",
      title: "Título",
      body: "Corpo",
      whom: "Para quem",
      date: "Data",
      message_type_enum: {
        EMAIL: "E-mail",
        SMS: "SMS",
        IN_APP: "Notificação"
      },
      message_importance_enum: {
        LOW: "Baixa",
        MEDIUM: "Média",
        HIGH: "Alta"
      },
      send_message: "Enviar Mensagem",
      success_message: "{1} enviado para {0} pessoa | {1} enviado para {0} pessoas"
    },
    suggestion: {
      category: "Categoria de Sugestão",
      title: "Sugestões",
      add_suggestion: "Adicionar Sugestão",
      body: "Mensagem",
      owner: "Proprietário"
    },
    note: {
      notes: "Notas",
      title: "Título",
      body: "Corpo",
      attachment: "Anexo",
      description: "Descrição",
      add_note: "Adicionar Nota",
      owner: "Funcionário",
      importance: "Importância"
    },
    travel: {
      request_travel: "Solicitar uma Viagem",
      leave_request: "Solicitação de Folga",
      travels: "Viagens",
      travel: "Viagem",
      travel_detail: "Detalhe da Viagem",
      start_work_date: "Data de Início do Trabalho",
      is_domestic: "É Doméstica?",
      country: "País",
      city: "Cidade",
      region: "Região",
      is_rent_car: "Alugar Carro?",
      is_shuttle: "Usar Transporte?",
      description: "Descrição",
      reason: "Motivo",
      status: "Status",
      expense_message: "<strong>{0}</strong> solicitou gastar <strong>{2}</strong> em <strong>{1}</strong>",
      imprest_message: "<strong>{0}</strong> solicitou um adiantamento de <strong>{2}</strong> em <strong>{1}</strong>",
      subsistence_message:
        "O funcionário <strong>{0}</strong> recebeu uma diária de <strong>{2}</strong> em <strong>{1}</strong>",
      travel_dates: "Datas da Viagem",
      pending_travel_approvals: "Aprovações de Viagem Pendentes",
      travel_process: "Processo de Viagem",
      travel_details: "Detalhes da Viagem",
      no_detail_item: "Sem item de detalhe",
      add_new_detail: "Adicionar Novo Detalhe",
      detail_type: "Tipo de Detalhe",
      detail_subtype: "Subtipo de Detalhe",
      travel_detail_type_enum: {
        TRANSFER: "Transferência",
        LAYOVER: "Escala",
        BUSINESS: "Negócios",
        TRAVEL_INSURANCE: "Seguro Viagem"
      },
      travel_detail_subtype_enum: {
        BUS: "Ônibus",
        PLANE: "Avião",
        TRAIN: "Trem",
        SHIP: "Navio",
        CAR: "Carro",
        HOTEL: "Hotel",
        HOSTEL: "Hostel",
        VILLA: "Vila",
        FACTORY: "Fábrica",
        OFFICE: "Escritório",
        TRAVEL_HEALTH_POLICY: "Política de Saúde em Viagem"
      },
      begin_date: "Data de Início",
      end_date: "Data de Término",
      expenses: "Despesas",
      imprests: "Adiantamentos",
      debits: "Débitos",
      borrow_date: "Data do Empréstimo",
      due_date: "Data de Vencimento",
      give_back_date: "Data de Devolução",
      quantity: "Quantidade",
      name: "Nome",
      category: "Categoria",
      model: "Modelo",
      subsistences: "Diárias",
      project: "Projeto",
      attrition: "Taxa de Atrito",
      new_leave_request: "Solicitar Folga",
      adding_expense: "Adicionando Despesa",
      adding_imprest: "Adicionando Adiantamento",
      adding_subsistence: "Adicionando Diária",
      adding_debit: "Adicionando Débito",
      assignment_form: "Formulário de Atribuição"
    },
    travel_request: {
      employee: "Funcionário",
      begin_date: "Data de Início",
      end_date: "Data de Término",
      start_work_date: "Data de Início do Trabalho",
      status: "Status",
      request_date: "Data da Solicitação",
      travel_approval: "Aprovação de Viagem",
      message: "<b>{0}</b> solicitou uma viagem entre <b>{1}</b> - <b>{2}</b>, deseja aprovar?"
    },
    vehicle: {
      plate_number: "Número da Placa",
      brand: "Marca",
      model: "Modelo",
      year: "Ano",
      branch: "Filial",
      employee: "Funcionário"
    },
    contact: {
      employee: "Funcionário",
      email: "E-mail",
      phone: "Número de Telefone"
    },
    projects: {
      project: "Projeto",
      employee_count_message: "Sem funcionários | 1 funcionário | {count} funcionários"
    },
    debit_ticket_transfer_request: {
      requester: "Solicitante",
      asset: "Ativo",
      approval_message:
        "<strong>{0}</strong> solicitou transferir o ativo com as seguintes informações para seu controle, deseja confirmar?"
    },
    survey: {
      name: "Nome da Pesquisa",
      published_date: "Data de Publicação",
      end_date: "Data de Término",
      start_survey: "Iniciar Pesquisa",
      survey_privacy: "Privacidade da Pesquisa",
      status: "Status",
      pending_title: "Pesquisas que Você Deve Completar",
      completed_title: "Pesquisas que Participei",
      expired_title: "Pesquisas Expiradas",
      complete_survey: "Completar Pesquisa",
      survey_information: "Informação da Pesquisa",
      exit: "Sair",
      save_and_finish: "Salvar e Finalizar",
      status_enum: {
        completed: "Completada",
        continuous: "Contínua",
        expired: "Expirada"
      },
      section_count: "Quantidade de Seções",
      question_count: "Quantidade de Questões",
      estimated_duration: "Duração Estimada",
      description: "Descrição",
      anonymous_on: "Votação Fechada",
      anonymous_off: "Votação Aberta",
      enter_answer: "Você pode inserir uma resposta",
      your_answer: "Sua resposta",
      please_select: "por favor selecione"
    },
    employee_requesting: "Solicitante",
    employee_creating: "Relator"
  },
  feedback: {
    reasons: "Motivos",
    reason: "Motivo",
    feeling: "Expressão facial",
    feeling_enum: {
      BAD: "Ruim",
      SAD: "Triste",
      NORMAL: "Normal",
      HAPPY: "Feliz",
      ECSTATIC: "Muito Feliz"
    },
    title: "Feedback {0} / {1}",
    comment: "Descrição"
  },
  menu: {
    dashboard: "Painel",
    time: "Tempo",
    hr: "Recursos Humanos",
    leave: "Folga",
    clock_in_out: "Entrada / Saída"
  },
  message: {
    saved_successfully: "Salvo com Sucesso",
    registration_failed: "Falha ao Salvar",
    updated_successfully: "Atualizado com Sucesso",
    deleted_successfully: "Excluído com Sucesso",
    download_email_report: "Clique no botão de download para baixar o arquivo",
    clock_ip_error: "O endereço IP não está entre os endereços IP permitidos",
    evaluation_date_range_error_message: "Você não está no período de avaliação ativo",
    leave_calculate_error: "Erro de cálculo",
    required_document_message: "Há um documento que você precisa enviar",
    notice_period_error: "Esta folga deve ser solicitada com pelo menos {0} dias de antecedência",
    max_consecutive_error: "Você pode solicitar até {0} dias de folga por vez",
    min_consecutive_error: "Você pode solicitar no mínimo {0} dias de folga por vez",
    leave_request_exist_error: "Já existe uma solicitação de folga nestas datas",
    total_leave_balance_error1: "Você não tem saldo suficiente para esta folga",
    total_leave_balance_error2:
      "Para esta folga, você pode usar no máximo {0} dias do saldo antecipado, você não pode solicitar folga porque seu saldo antecipado é insuficiente.",
    network_error: "Erro de Rede",
    no_record_found: "Nenhum Registro Encontrado",
    max_range_error: "Você pode escolher no máximo {0} dias!",
    something_went_wrong: "Desculpe, algo deu errado",
    less_than_x_mb_error: "O tamanho máximo do arquivo deve ser {0} MB",
    delete_warning_message: "Este registro será excluído, tem certeza?",
    delete_operation: "Operação de Exclusão"
  },
  global: {
    comment: "Comentário",
    description: "Descrição",
    day: "Dia",
    note: "Nota",
    employee: "Funcionário",
    address: "Endereço",
    explanation: "Explicação",
    hour: "Hora",
    month: "Mês",
    phone: "Telefone",
    status: "Status",
    file: "Arquivo",
    greeting: "Olá, {0}",
    search_for_employee: "Procurar funcionário...",
    others: "Outros",
    importance_enum: {
      LOW: "Baixa",
      MEDIUM: "Média",
      HIGH: "Alta"
    },
    importance: "Importância",
    date: "Data",
    loading_message: "Carregando...",
    birth_date: "Data de Nascimento",
    min_character_message: "Você deve inserir pelo menos {0} caracteres",
    no_employee_message: "Nenhum funcionário foi encontrado nos critérios pesquisados.",
    employees: "Funcionários",
    beginDate: "Data de Início",
    endDate: "Data de Término",
    beginTime: "Hora de Início",
    endTime: "Hora de Término",
    year: "Ano",
    message: "Mensagem",
    detail: "Detalhe",
    country: "País",
    active_employees: "Funcionários Ativos",
    passive_employees: "Funcionários Inativos",
    maxEmployeeCount: "Quantidade Máxima de Funcionários",
    years_old: "anos de idade",
    print: "Imprimir",
    expense_management: "Gestão de Despesas",
    paymentType: "Tipo de Pagamento",
    employee_selected: "Selecione funcionário...|1 funcionário selecionado|{count} funcionários selecionados",
    shift_selected: "Selecione turno...|1 turno selecionado|{count} turnos selecionados",
    shifts_type: "{0} Turnos",
    total_hours: "Total de Horas",
    name: "Nome",
    reason: "Motivo",
    organization: "organização",
    minute: "Minuto",
    from: "De",
    to: "Até",
    shift: "Turno",
    uploaded_files: "Arquivos Enviados",
    manager: "Gestor",
    selected: "{0} selecionado",
    search: "Pesquisar",
    file_preview: "Visualização do Arquivo",
    filename: "Nome do Arquivo",
    error: "Erro",
    completed: "Concluído",
    drop_files: "Arraste e solte arquivos aqui ou clique para selecionar arquivos",
    loading: "Carregando..."
  },
  assessment: {
    very_poor: "Muito Ruim",
    poor: "Ruim",
    normal: "Normal",
    good: "Bom",
    very_good: "Muito Bom",
    na: "Não Avaliado"
  },
  buttons: {
    home: "Painel",
    ok: "Ok",
    delete: "Excluir",
    back: "Voltar",
    save: "Salvar",
    update: "Atualizar",
    edit: "Editar",
    cancel: "Cancelar",
    close: "Fechar",
    dont_save: "Sair sem salvar",
    dont_save_continue: "Continuar sem salvar",
    save_changes: "Salvar Alterações",
    evaluation_finish: "Finalizar Avaliação",
    assign: "Atribuir",
    add: "Adicionar {0}",
    add_and_new: "Adicionar e Novo",
    refresh: "Atualizar",
    filter: "Filtrar",
    export: "Exportar",
    create: "Criar {0}",
    create_and_new: "Criar e Novo",
    download: "Baixar",
    yes: "Sim",
    no: "Não",
    clear: "Limpar",
    filter_results: "Filtrar Resultados",
    delete_document: "Excluir Documento",
    scan: "Digitalizar",
    send_message: "Enviar Mensagem",
    send: "Enviar",
    apply: "Aplicar",
    info: "Informação",
    prev: "Anterior {0}",
    next: "Próximo {0}",
    list_table: "Modo Tabela",
    list_card: "Modo Cartão",
    continue: "Continuar",
    show_all: "Mostrar Tudo",
    cancel_leave: "Cancelar Folga",
    select_all: "Selecionar Tudo",
    upload: "Enviar",
    file_upload: "Envio de Arquivo",
    file_download: "Operações de Arquivo",
    import: "Importar",
    upload_template: "Enviar Modelo",
    download_template: "Baixar Modelo",
    trigger: "Disparar",
    action: "Ação",
    send_registration_credentials: "Enviar Credenciais de Registro",
    on: "Ligado",
    off: "Desligado",
    uploads: {
      employee: "Importar Funcionários",
      leave: "Importar Folgas"
    },
    multiple_delete_shift: "Exclusão em Lote de Turnos",
    multiple_upload_shift: "Envio em Lote de Turnos",
    multiple_actions: "Ações em Lote",
    send_email_and_sms_notification: "Enviar Notificação por E-mail e SMS",
    add_expense: "Adicionar Despesa",
    add_imprest: "Solicitar um Adiantamento",
    add_overtime: "Solicitar Hora Extra",
    add_leave_request: "Adicionar Solicitação de Folga",
    evaluatee: "Avaliado",
    add_skill: "Adicionar Habilidade",
    sign: "Assinar",
    skip: "Pular",
    back_to_home: "Voltar para Início",
    please_select: "Por favor selecione...",
    preview: "Visualizar"
  },
  response: {
    success: {
      ok: "A operação foi bem-sucedida",
      update: "Atualizado com Sucesso",
      delete: "Excluído com Sucesso",
      send_sms_password_code: "O código de redefinição de senha foi enviado como mensagem SMS"
    },
    error: {
      user_not_found: "Nome de usuário ou senha inválidos",
      network_error: "Erro de Rede"
    }
  },
  request_status: {
    PENDING: "Aguardando Aprovação",
    pending: "Aguardando Aprovação",
    approved: "Aprovado",
    APPROVED: "Aprovado",
    denied: "Negado",
    DENIED: "Negado",
    cancelled: "Cancelado",
    CANCELLED: "Cancelado",
    NEED_EXTRA_DETAIL: "Necessita Detalhes Adicionais",
    need_extra_detail: "Necessita Detalhes Adicionais",
    undefined: "Indefinido"
  },
  shift_types: {
    FIX: "Fixo",
    FLEXIBLE: "Flexível",
    OFF_DAY: "Dia de Folga",
    OFFDAY: "Dia de Folga",
    HOLIDAY: "Feriado",
    WORKDAY: "Dia Útil",
    BREAK: "Intervalo",
    OVERTIME: "Hora Extra",
    OVERTIME_SHIFT: "Hora Extra",
    ON_LEAVE: "Em Folga"
  },
  shift: {
    overtime: "Hora Extra",
    missing_time: "Tempo Faltante",
    shift_parameters: "Parâmetros do Turno",
    break: "Intervalo",
    sub_events: "Sub Eventos",
    included_calculation: "Incluído no cálculo",
    not_included_calculation: "Não incluído no cálculo",
    included_overtime_calculation: "Hora extra não incluída no cálculo",
    not_included_overtime_calculation: "Hora extra incluída no cálculo",
    not_included_missing_time_calculation: "Tempo faltante não incluído no cálculo",
    included_missing_time_calculation: "Tempo faltante incluído no cálculo",
    work_day: "Dia Útil",
    overtime_day: "Dia de Hora Extra",
    full_time: "Tempo Integral",
    absent: "Ausente",
    unpaid_leave: "Folga Não Remunerada",
    paid_leave: "Folga Remunerada",
    public_holiday: "Feriado",
    on_leave: "Em Folga",
    off_day: "Dia de Folga",
    break_day: "Dia de Intervalo",
    incalculable: "Turno Incalculável"
  },
  sensors: {
    NFC: "Nfc",
    FACE: "Face",
    RFID: "Rfid",
    FINGER: "Digital",
    BLUETOOTH: "Bluetooth",
    GATEWARE: "Gateware",
    BEACON: "Beacon",
    GPS: "Gps",
    WIFI: "Wifi",
    ID: "Id",
    QR: "Qr",
    QR_CODE: "Código QR",
    PASSWORD: "Senha",
    PIN: "Pin",
    CARD: "Cartão",
    FIXED: "Fixo",
    EXTERNAL: "Externo",
    JAN: "JAN",
    WEB: "Web"
  },
  identity_type: {
    FACE: "Face",
    PASSWORD: "Senha",
    PIN: "Pin",
    FINGER: "Digital",
    QR_CODE: "Código QR",
    CARD: "Cartão",
    EXTERNAL: "Externo"
  },
  event_types: {
    BREAK_IN: "Entrada Intervalo",
    BREAK_OUT: "Saída Intervalo",
    LUNCH_IN: "Entrada Almoço",
    LUNCH_OUT: "Saída Almoço",
    DUTY_IN: "Entrada Turno",
    DUTY_OUT: "Saída Turno",
    CLOCK_IN: "Entrada",
    CLOCK_OUT: "Saída",
    UNKNOWN: "Entrada ou Saída",
    undefined: "Desconhecido"
  },
  currency: {
    amount: "Valor",
    code: "Código",
    requested_amount: "Valor Solicitado",
    approved_amount: "Valor Aprovado",
    codes: {
      TRY: "TRY",
      USD: "USD",
      EUR: "EUR",
      RON: "LEU",
      GBP: "STERLIN",
      AZN: "MANAT",
      RUB: "RUBLE",
      SAR: "RİYAL",
      AED: "UAE-Dirham"
    }
  },
  titles: {
    expense: {
      create: "Adicionar Despesa",
      detail: "Detalhes da Despesa"
    },
    imprest: {
      create: "Adicionar Adiantamento",
      detail: "Detalhes do Adiantamento"
    }
  },
  language: {
    tr: "Turco",
    en: "Inglês",
    de: "Alemão",
    es: "Espanhol",
    it: "Italiano",
    pt: "Português",
    TURKISH: "Turco",
    ENGLISH: "Inglês",
    GERMAN: "Alemão",
    SPANISH: "Espanhol",
    ITALIAN: "Italiano",
    PORTUGUESE: "Português"
  },
  status: {
    active: "Ativo",
    passive: "Inativo",
    enable: "Habilitado",
    disable: "Desabilitado"
  },
  gender: {
    male: "Masculino",
    female: "Feminino",
    other: "Outro",
    others: "Outros",
    MALE: "Masculino",
    FEMALE: "Feminino",
    OTHER: "Outro"
  },
  marital_status: {
    married: "Casado",
    single: "Solteiro",
    divorced: "Divorciado"
  },
  education: {
    student: "Estudante",
    primary_school: "Ensino Fundamental I",
    secondary_school: "Ensino Fundamental II",
    high_school: "Ensino Médio",
    collage: "Técnico",
    university: "Graduação",
    master: "Mestrado",
    phd: "Doutorado"
  },
  education_languages: {
    turkish: "Turco",
    english: "Inglês",
    german: "Alemão",
    french: "Francês",
    dutch: "Holandês",
    spanish: "Espanhol",
    italian: "Italiano",
    arabic: "Árabe",
    russian: "Russo",
    persian: "Persa",
    chinese: "Chinês",
    japanese: "Japonês",
    hindi: "Hindi",
    latin: "Latim",
    portuguese: "Português",
    korean: "Coreano"
  },
  military_service: {
    done: "Concluído",
    undone: "Não Concluído",
    exempt: "Isento",
    suspended: "Suspenso"
  },
  academic_title: {
    lecturer: "Professor",
    research_assistant: "Assistente de Pesquisa",
    assistant_professor: "Professor Assistente",
    associate_professor: "Professor Associado",
    professor: "Professor Titular"
  },
  employment_type: {
    full_time: "Tempo Integral",
    part_time: "Meio Período",
    casual: "Eventual",
    contracted: "Contratado",
    freelance: "Autônomo",
    intern: "Estagiário",
    mobile: "Móvel",
    retired: "Aposentado",
    trial: "Período de Experiência",
    seasonal: "Temporário",
    disabled: "Deficiente"
  },
  collar_type: {
    white: "Branco",
    blue: "Azul",
    gray: "Cinza"
  },
  quite_job_reasons: {
    resignation: "Demissão",
    cancellation_of_labor_contract: "Rescisão de Contrato",
    military_service: "Serviço Militar",
    other: "Outro"
  },
  blood_type: {
    o_rh_negative: "O-",
    o_rh_positive: "O+",
    a_rh_negative: "A-",
    a_rh_positive: "A+",
    b_rh_negative: "B-",
    b_rh_positive: "B+",
    ab_rh_negative: "AB-",
    ab_rh_positive: "AB+"
  },
  time_duration: {
    hour: "Hora",
    minute: "Minuto",
    second: "Segundo"
  },
  date: {
    year: "Ano",
    month: "Mês",
    day: "Dia",
    time: "Hora",
    week: "Semana",
    minute: "Minuto"
  },
  validations: {
    messages: {
      phone: "O campo {_field_} deve ser um número de telefone válido",
      password_match: "As senhas não coincidem",
      integer: "O campo {_field_} deve ser um número inteiro",
      meaningful_text: "Digite uma descrição significativa.",
      amount_range_error: "O valor deste campo deve estar entre {min} e {max}."
    }
  },
  nationalities: {
    Afghan: "Afegão",
    Albanian: "Albanês",
    Algerian: "Argelino",
    American: "Americano",
    Andorran: "Andorrano",
    Angolan: "Angolano",
    Antiguans: "Antiguano",
    Argentinean: "Argentino",
    Armenian: "Armênio",
    Australian: "Australiano",
    Austrian: "Austríaco",
    Azerbaijani: "Azerbaijano",
    Bahamian: "Bahamense",
    Bahraini: "Bareinita",
    Bangladeshi: "Bangladês",
    Barbadian: "Barbadiano",
    Barbudans: "Barbudano",
    Botswana: "Botsuano",
    Belarusian: "Bielorrusso",
    Belgian: "Belga",
    Belizean: "Belizenho",
    Beninese: "Beninês",
    Bhutanese: "Butanês",
    Bolivian: "Boliviano",
    Bosnian: "Bósnio",
    Brazilian: "Brasileiro",
    British: "Britânico",
    Bruneian: "Bruneano",
    Bulgarian: "Búlgaro",
    Burkinabe: "Burquinês",
    Burmese: "Birmanês",
    Burundian: "Burundiano",
    Cambodian: "Cambojano",
    Cameroonian: "Camaronês",
    Canadian: "Canadense",
    "Cape Verdean": "Cabo-verdiano",
    "Central African": "Centro-africano",
    Chadian: "Chadiano",
    Chilean: "Chileno",
    Chinese: "Chinês",
    Colombian: "Colombiano",
    Comoran: "Comorense",
    Congolese: "Congolês",
    "Costa Rican": "Costarriquenho",
    Croatian: "Croata",
    Cuban: "Cubano",
    Cypriot: "Cipriota",
    Czech: "Tcheco",
    Danish: "Dinamarquês",
    Djibouti: "Djibutiense",
    Dominican: "Dominicano",
    Dutch: "Holandês",
    "East Timorese": "Timorense",
    Ecuadorean: "Equatoriano",
    Egyptian: "Egípcio",
    Emirian: "Emiradense",
    "Equatorial Guinean": "Guineense Equatorial",
    Eritrean: "Eritreu",
    Estonian: "Estoniano",
    Ethiopian: "Etíope",
    Fijian: "Fijiano",
    Filipino: "Filipino",
    Finnish: "Finlandês",
    French: "Francês",
    Gabonese: "Gabonês",
    Gambian: "Gambiano",
    Georgian: "Georgiano",
    German: "Alemão",
    Ghanaian: "Ganês",
    Greek: "Grego",
    Grenadian: "Granadino",
    Guatemalan: "Guatemalteco",
    "Guinea-Bissauan": "Guineense-Bissau",
    Guinean: "Guineense",
    Guyanese: "Guianês",
    Haitian: "Haitiano",
    Herzegovinian: "Herzegovino",
    Honduran: "Hondurenho",
    Hungarian: "Húngaro",
    "I-Kiribati": "Kiribatiano",
    Icelander: "Islandês",
    Indian: "Indiano",
    Indonesian: "Indonésio",
    Iranian: "Iraniano",
    Iraqi: "Iraquiano",
    Irish: "Irlandês",
    Israeli: "Israelense",
    Italian: "Italiano",
    Ivorian: "Marfinense",
    Jamaican: "Jamaicano",
    Japanese: "Japonês",
    Jordanian: "Jordaniano",
    Kazakhstani: "Cazaque",
    Kenyan: "Queniano",
    "Kittian and Nevisian": "São-cristovense",
    Kuwaiti: "Kuwaitiano",
    Kyrgyz: "Quirguiz",
    Laotian: "Laosiano",
    Latvian: "Letão",
    Lebanese: "Libanês",
    Liberian: "Liberiano",
    Libyan: "Líbio",
    Liechtensteiner: "Liechtensteinense",
    Lithuanian: "Lituano",
    Luxembourger: "Luxemburguês",
    Macedonian: "Macedônio",
    Malagasy: "Malgaxe",
    Malawian: "Malauiano",
    Malaysian: "Malaio",
    Maldivan: "Maldivo",
    Malian: "Maliano",
    Maltese: "Maltês",
    Marshallese: "Marshallês",
    Mauritanian: "Mauritano",
    Mauritian: "Mauriciano",
    Mexican: "Mexicano",
    Micronesian: "Micronésio",
    Moldovan: "Moldavo",
    Monacan: "Monegasco",
    Mongolian: "Mongol",
    Moroccan: "Marroquino",
    Mosotho: "Lesotiano",
    Motswana: "Botsuano",
    Mozambican: "Moçambicano",
    Namibian: "Namibiano",
    Nauruan: "Nauruano",
    Nepalese: "Nepalês",
    "New Zealander": "Neozelandês",
    Nicaraguan: "Nicaraguense",
    Nigerian: "Nigeriano",
    Nigerien: "Nigerino",
    "North Korean": "Norte-coreano",
    "Northern Irish": "Norte-irlandês",
    Norwegian: "Norueguês",
    Omani: "Omanense",
    Pakistani: "Paquistanês",
    Palauan: "Palauano",
    Panamanian: "Panamenho",
    "Papua New Guinean": "Papua-nova-guineense",
    Paraguayan: "Paraguaio",
    Peruvian: "Peruano",
    Polish: "Polonês",
    Portuguese: "Português",
    Qatari: "Catariano",
    Romanian: "Romeno",
    Russian: "Russo",
    Rwandan: "Ruandês",
    "Saint Lucian": "Santa-lucense",
    Salvadoran: "Salvadorenho",
    Samoan: "Samoano",
    "San Marinese": "São-marinense",
    "Sao Tomean": "São-tomense",
    Saudi: "Saudita",
    Scottish: "Escocês",
    Senegalese: "Senegalês",
    Serbian: "Sérvio",
    Seychellois: "Seichelense",
    "Sierra Leonean": "Serra-leonês",
    Singaporean: "Singapuriano",
    Slovakian: "Eslovaco",
    Slovenian: "Esloveno",
    "Solomon Islander": "Salomônico",
    Somali: "Somali",
    "South African": "Sul-africano",
    "South Korean": "Sul-coreano",
    Spanish: "Espanhol",
    "Sri Lankan": "Sri-lankês",
    Sudanese: "Sudanês",
    Surinamer: "Surinamês",
    Swazi: "Suazi",
    Swedish: "Sueco",
    Swiss: "Suíço",
    Syrian: "Sírio",
    Taiwanese: "Taiwanês",
    Tajik: "Tajique",
    Tanzanian: "Tanzaniano",
    Thai: "Tailandês",
    Togolese: "Togolês",
    Tongan: "Tonganês",
    "Trinidadian or Tobagonian": "Trinitário",
    Tunisian: "Tunisiano",
    Turkish: "Turco",
    Tuvaluan: "Tuvaluano",
    Ugandan: "Ugandês",
    Ukrainian: "Ucraniano",
    Uruguayan: "Uruguaio",
    Uzbekistani: "Uzbeque",
    Venezuelan: "Venezuelano",
    Vietnamese: "Vietnamita",
    Welsh: "Galês",
    Yemenite: "Iemenita",
    Zambian: "Zambiano",
    Zimbabwean: "Zimbabuano"
  },
  disability_level: {
    first_level: "Primeiro Nível",
    second_level: "Segundo Nível",
    third_level: "Terceiro Nível"
  },
  social_security_type: {
    SS_4A: "4A",
    SS_4B: "4B",
    SS_4C: "4C"
  },
  clock_ip_error: "O endereço IP não está entre os endereços IP permitidos",
  days: {
    monday: "Segunda-feira",
    tuesday: "Terça-feira",
    wednesday: "Quarta-feira",
    thursday: "Quinta-feira",
    friday: "Sexta-feira",
    saturday: "Sábado",
    sunday: "Domingo"
  },
  api_error: {
    756: "Existe uma solicitação de folga entre as datas solicitadas",
    766: "Sua senha deve ter no mínimo 8 e no máximo 16 caracteres",
    767: "Sua senha deve conter letras minúsculas, maiúsculas, números e caracteres especiais: .-/@#$%^&_+=()",
    768: "Sua senha não pode incluir seu nome, sobrenome ou número de funcionário",
    769: "Esta senha já foi usada anteriormente, insira uma senha diferente das suas últimas {0} senhas",
    800: "Tentativa de login falhou",
    801: "Erro de verificação SMS",
    802: "Muitas tentativas falhas de verificação OTP",
    803: "Identidade não encontrada",
    804: "Acesso móvel desativado",
    805: "Credenciais inválidas",
    806: "Erro de verificação de senha",
    807: "Login SSO falhou",
    808: "Erro de verificação do Captcha",
    809: "Verificação do dispositivo falhou",
    810: "Erro de verificação do canal",
    811: "Erro de autenticação",
    812: "Erro de verificação JWT",
    813: "Falha na verificação do código TOTP",
    814: "O tipo SSO não pode ser nulo"
  },
  http: {
    200: "Enviado com sucesso",
    201: "Sucesso",
    202: "Salvo com sucesso",
    401: "Não autorizado",
    404: "Não encontrado",
    409: "Conflito de dados",
    415: "Tipo de mídia não suportado",
    204: "Sucesso",
    304: "Não modificado",
    500: "Erro interno do servidor",
    503: "Serviço indisponível"
  },
  expense_items: "Itens de Despesa",
  expense_item_name: "Nome do Item de Despesa",
  update_expense_item: "Atualizar Item de Despesa",
  add_expense_item: "Adicionar Item de Despesa",
  file_format_error: "Erro de Formato de Arquivo",
  file_size_error: "Erro de Tamanho de Arquivo",
  not_selected_expense_item_error_message: "Você não adicionou um item de despesa",
  expense_description: "Descrição da Despesa",
  abolisher_employee: "Funcionário Abolidor",
  expense_manager: "Gerente de Despesas",
  event_date: "Data do Evento",
  cancelled_date: "Data de Cancelamento",
  approval_history: "Histórico de Aprovação",
  request_processes: {
    super_admin: "Aprovado pelo Super Admin",
    approved: "Solicitação aprovada",
    pending: "Aguardando aprovação",
    stopped: "Processo de aprovação interrompido porque a solicitação foi rejeitada",
    waiting: "Ainda não é hora da aprovação",
    denied: "Solicitação negada"
  },
  sso_forgot_password_warning: {
    title: "Aviso",
    message: "Por favor, faça login no Idenfit usando seu e-mail Accenture."
  },
  time_abbr: {
    hour: "h",
    minute: "min",
    second: "seg"
  },
  vedubox_user_not_found: "Usuário Vedubox Não Encontrado",
  gdpr: {
    acceptance: {
      title: "Aceitação GDPR",
      checkbox: "Eu aceito o consentimento GDPR.",
      save: "Salvar e Continuar",
      formError: "Você deve aceitar o consentimento GDPR para continuar."
    }
  },
  web_terminal_loading: "Terminal web está carregando",
  web_terminal_not_found: "Terminal web não encontrado",
  multiple_assigned_shift_warning: "Você tem mais de um turno atribuído. Por favor, escolha um dos turnos abaixo.",
  paper_approval: "Aprovação em Papel",
  paperApprovalProcessWarningMessage: "Você precisa baixar ou visualizar o arquivo",
  minLength: "Mínimo de 8 caracteres",
  hasLowerCaseAndUpperCase: "Contém dígito, letras maiúsculas e minúsculas",
  hasSpecialCharacter: "Contém caracteres especiais",
  passwordExpireNotificationMessage:
    "Falta 0 dia para sua senha expirar | Falta 1 dia para sua senha expirar | Faltam {count} dias para sua senha expirar",
  pendingRequests: "Solicitações Pendentes",
  allPendingRequests: "Todas as Solicitações Pendentes",
  maxImprestAmountMessage: "Limite máximo que pode ser solicitado: {0}",
  or: "ou",
  continueWithMicrosoft: "Continuar com Microsoft",
  authCode: "Código de Autenticação",
  verify: "Verificar",
  totpVerifyMessage:
    "Você precisa abrir o aplicativo de autenticação de dois fatores para ver o código de autenticação",
  totpCodeInvalid: "Você inseriu um código de autenticação inválido",
  totpRegisterMessage1:
    "Escaneie o código QR abaixo com o aplicativo de autenticação de dois fatores no seu telefone. Se você não conseguir escanear o código QR, use este código <strong>{0}</strong> em vez disso.",
  totpRegisterMessage2: "Digite o código de seis dígitos do aplicativo abaixo",
  taskManagement: {
    task: "Tarefa",
    tasks: "Tarefas",
    parentTask: "Tarefa Principal",
    categories: "Categorias",
    completed: "Concluída",
    notCompleted: "Não Concluída",
    addTask: "Adicionar Tarefa",
    taskDetail: "Detalhes da Tarefa",
    title: "Título",
    sender: "Criado Por",
    senders: "Criadores",
    taskCategory: "Categoria da Tarefa",
    taskCategories: "Categorias de Tarefas",
    followers: "Seguidores",
    addTaskCategory: "Adicionar Categoria",
    taskCategoryDetail: "Detalhes da Categoria",
    labels: "Etiquetas",
    labelPlaceholder: "Digite o nome da etiqueta e pressione Enter ou clique no botão para adicioná-la",
    taskCompleted: "Tarefa Concluída",
    taskNotCompleted: "Tarefa Não Concluída",
    attachments: "Anexos",
    uploadFile: "Clique para enviar arquivo",
    details: "Detalhes",
    conversation: "Comentário",
    conversations: "Comentários",
    noConversation: "Nenhum comentário feito",
    notify: "Ativar Notificações",
    responsibles: "Responsáveis",
    writeComment: "Escreva um comentário...",
    subtasks: "Subtarefas",
    importance: "Prioridade",
    completedTasks: "Tarefas Concluídas",
    notCompletedTasks: "Tarefas Não Concluídas",
    subtasksMustBeCompleted: "As subtarefas devem ser concluídas antes de completar a tarefa principal",
    subtaskModificationNotAllowed: "Não pode ser modificada porque a tarefa principal está concluída",
    updatedDateTime: "Data da Última Edição",
    filterByTitle: "Filtrar por Título",
    filterTasks: "Filtrar Tarefas",
    onlyMyTasks: "Tarefas Criadas por Mim",
    onlyMyFollowedTasks: "Tarefas que Sigo",
    onlyMyResponsibleTasks: "Tarefas sob Minha Responsabilidade",
    onlyMyTeamTasks: "Tarefas da Minha Equipe",
    selectTaskView: "Selecionar Visualização de Tarefas",
    reportFileName: "relatorio_tarefas"
  },
  dynamicFields: {
    title: "Campos Dinâmicos"
  },
  file: {
    preview: "Pré-visualização do arquivo",
    download: "Baixar",
    download_error: "Falha no download",
    unsupported_format: "Este formato de arquivo não é compatível com a visualização"
  }
};
